import { Button } from '@hub-la/shadcn'
import { ExternalLink } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { IntegrationProvider } from '../../../domain/dtos/integration-provider'
import { useCreateIntegration } from '../../hooks/use-create-integration'

type Props = {
  provider: IntegrationProvider
  integrationId?: string
  loading: boolean
  refetch: () => void
  setTab: (name: string) => void
}

export const SellFluxCardActions = ({ provider, integrationId, loading, refetch, setTab }: Props) => {
  const { t } = useTranslation()

  const { isLoading, mutateAsync: createIntegration } = useCreateIntegration()

  const handleCreateIntegration = async () => {
    await createIntegration({ provider })
    refetch()
  }

  return (
    <div className="w-full flex flex-col items-center justify-between gap-2">
      {!integrationId ? (
        <Button className="w-full" loading={loading || isLoading} onClick={async () => handleCreateIntegration()}>
          {t(`buttons.activeIntegration`)}
        </Button>
      ) : (
        <Button className="w-full" variant="outline" loading={loading || isLoading} onClick={() => setTab('settings')}>
          {t(`buttons.settings`)}
        </Button>
      )}

      <Button
        variant="ghost"
        className="w-full text-muted-foreground hover:text-foreground"
        onClick={() => window.open(t(`integrations.${provider}.about.link`), '_blank')}
      >
        <span className="flex items-center gap-2">
          {t('aboutTab.seeMore')}
          <ExternalLink size={16} />
        </span>
      </Button>
    </div>
  )
}
